import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatisticComponent } from './statistic.component';
import {
  ButtonModule,
  DropdownModule,
  ProgressModule,
  SvgIconModule,
  TableModule,
  TextFieldModule,
  UtilsModule
} from '@mtgame/ui';
import { RouterModule } from '@angular/router';
import { ROUTES } from './statistic.routes';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { StatisticTableModule } from '../../shared/statistic-table/statistic-table.module';
import { StatisticTableGroupedModule } from '../../shared/statistic-table-grouped/statistic-table-grouped.module';
import { StatisticService } from '@core/services/statistic.service';
import { statisticFactory } from '@core/services/statistic.factory';
import { StatisticResolver } from './statistic.resolver';
import { HockeyStatisticService } from '@core/services/hockey-statistic.service';
import { BasketballStatisticService } from '@core/services/basketball-statistic.service';
import { VolleyballStatisticService } from '@core/services/volleyball-statistic.service';
import { FootballStatisticService } from '@core/services/football-statistic.service';
import { HandballStatisticService } from '@core/services/handball-statistic.service';
import { StatisticLeadersModule } from '../../shared/statistic-leaders/statistic-leaders.module';
import { RugbyStatisticService } from '@core/services/rugby-statistic.service';
import { StatisticFiltersWidgetModule } from '../../shared/statistic-filters-widget/statistic-filters-widget.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    DropdownModule,
    TableModule,
    TextFieldModule,
    UtilsModule,
    ReactiveFormsModule,
    SvgIconModule,
    SharedModule,
    ButtonModule,
    StatisticTableModule,
    StatisticTableGroupedModule,
    StatisticLeadersModule,
    StatisticFiltersWidgetModule,
    ProgressModule,
  ],
  declarations: [
    StatisticComponent,
  ],
  providers: [
    HockeyStatisticService,
    BasketballStatisticService,
    VolleyballStatisticService,
    FootballStatisticService,
    HandballStatisticService,
    RugbyStatisticService,
    {
      provide: StatisticService,
      useFactory: statisticFactory,
      deps: [Injector],
    },
    StatisticResolver,
  ]
})
export class StatisticModule {}
